import FingoPaper from '@fingo/lib/components/layout/FingoPaper';
import React from 'react';
import { settingsTabs } from '../../../routes/profile';

const ProfileSideSettings = () => {
  const tabs = settingsTabs();
  return <FingoPaper tabs={tabs} />;
};

export default ProfileSideSettings;
